import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import CustomCaption from '../../../../framework/summaryFormate/CustomCaption';
import CommodityDetailsSummary from '../../../../container/shipment/addShipment/addShipmentSummary/CommodityDetailsSummary';
import { CLERANCE_DECLARATION } from '../../../../utils/constants/constants';

const useStyles = makeStyles({
  flexContainer: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    paddingLeft: '10px',
  },
  rowDiff: {
    marginTop: '5px',
    marginBottom: '10px',
  },
});

const ClearanceDeclarationSummary = ({ shipmentData }) => {
  const {
    shipmentMovementType,
    totalValue,
    recipientUKIMSNumber,
    recipientEORINumber,
    sendersEORINumber,
    sendersUKIMSNumber,
    shippingCharges,
    reasonForExport,
    sendersDefermentAccount = shipmentData.shipper.defermentAccount,
  } = shipmentData || {};
  const classes = useStyles();
  const [commodityDetails, setCommodityDetails] = useState({});
  const CustomGridItem = ({ title, value }) => (
    <Grid item className={classes.flexContainer}>
     <CustomCaption title={title} value={value !== undefined && value !== null && value !== '' && value !== 0 ? value : (value === 0 ? '0' : '-')} />
    </Grid>
  );

  /**
   * Method to parse the commodity details
   * @returns - object
   */
  const parseCommodityDetails = () => {
    return shipmentData?.clearanceItems?.map((commodity) => {
      return {
        ...commodity,
        commodityCode: commodity?.commodityCode,
        fullDescriptionOfGoods: commodity?.descriptionOfGoods,
        weight: commodity?.weight,
        unitValue: commodity?.value,
        quantity: commodity?.quantity,
        countryOfOrigin: {
          code: commodity?.countryOfManufacture,
        },
      };
    });
  };

  useEffect(() => {
    const newCommodityDetails = {
      commodityDetails: parseCommodityDetails(),
    };
    setCommodityDetails(newCommodityDetails);
  }, [shipmentData]);

  const getDescriptionOfGoods = (shipmentData) => {
    if (shipmentData && shipmentData?.clearanceItems && shipmentData?.clearanceItems?.length > 0) {
      return shipmentData?.clearanceItems[0]?.descriptionOfGoods;
    } else {
      return '-';
    }
  };

  if (shipmentData?.recipient?.clearanceRegistrations) {
    shipmentData.recipient.clearanceRegistrations.forEach((registration) => {
      if (registration?.type === CLERANCE_DECLARATION.EORI_CONST) {
        shipmentData.recipientEORINumber = registration?.value;
      } else if (registration?.type === CLERANCE_DECLARATION.UKIMS_CONST) {
        shipmentData.recipientUKIMSNumber = registration?.value;
      }
    });
  }

  if (shipmentData?.shipper?.clearanceRegistrations) {
    shipmentData.shipper.clearanceRegistrations.forEach((registration) => {
      if (registration?.type === CLERANCE_DECLARATION.EORI_CONST) {
        shipmentData.sendersEORINumber = registration?.value;
      } else if (registration?.type === CLERANCE_DECLARATION.UKIMS_CONST) {
        shipmentData.sendersUKIMSNumber = registration?.value;
      }
    });
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography m={2} className={classes.rowDiff}>
          {CLERANCE_DECLARATION.SHIPMENT_MOVEMENT_TYPE} {shipmentMovementType ?? '-'}
        </Typography>
      </Grid>

      {shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_C2C && (
        <>
          <CustomGridItem title={CLERANCE_DECLARATION.GOODS_DESCRIPTION} value={getDescriptionOfGoods(shipmentData)} />
          <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={totalValue} />
        </>
      )}

      {shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_C2B && (
        <>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={totalValue} />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_UKIMS_NUMBER} value={recipientUKIMSNumber} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_EORI_NUMBER} value={recipientEORINumber} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B && (
        <>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={totalValue} />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_UKIMS_NUMBER} value={sendersUKIMSNumber} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_EORI_NUMBER} value={sendersEORINumber} />
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_UKIMS_NUMBER} value={recipientUKIMSNumber} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.RECIPIENT_EORI_NUMBER} value={recipientEORINumber} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2C && (
        <>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <CustomGridItem title={CLERANCE_DECLARATION.TOTAL_VALUE} value={totalValue} />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_UKIMS_NUMBER} value={sendersUKIMSNumber} />
              </Grid>
              <Grid item xs={6}>
                <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_EORI_NUMBER} value={sendersEORINumber} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {shipmentMovementType !== CLERANCE_DECLARATION.MOVEMENT_TYPE_C2C && (
        <Grid item xs={12}>
          <CommodityDetailsSummary
            shipmentDetails={commodityDetails}
            isClearance={true}
            shipmentMovementType={shipmentMovementType}
          />
        </Grid>
      )}

      {shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B && !sendersUKIMSNumber && (
        <>
          <CustomGridItem title={CLERANCE_DECLARATION.SHIPPING_CHARGES} value={shippingCharges}  />
          <CustomGridItem title={CLERANCE_DECLARATION.REASON_FOR_EXPORT} value={reasonForExport} />
          <CustomGridItem title={CLERANCE_DECLARATION.SHIPPER_DEFERMENT_NUMBER} value={sendersDefermentAccount} />
        </>
      )}
    </Grid>
  );
};

ClearanceDeclarationSummary.propTypes = {
  shipmentData: PropTypes.object.isRequired,
};

export default ClearanceDeclarationSummary;
